module.exports = __webpack_public_path__ + "img/pauli-y-root-dagger-7.2caae048.svg";